import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Space, Table } from "antd";
import { Box, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import qs from "qs";
import { handleApiError } from "../utils/errorHandler";

const WaTeamVersion2 = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editWaTeamVersionTwoId, setEditWaTeamVersionTwoId] = useState(null);

  const [wateamversiontwo, setWaTeamVersionTwo] = useState({
    connectionname: "",
    apiurl: "",
    crmapikey: "",
    phonenumberid: "",
    whatsappbusinessid: "",
    accesstoken: "",
  });

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const fetchWaTeamVersionTwoData = async () => {
    try {
      const params = {
        startreq:
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize,
        limit: tableParams.pagination.pageSize,
      };
      const response = await axios.get(
        `/api/whatsappv2/getall?${qs.stringify(params)}`
      );
      setData(response.data);
    } catch (error) {
      console.log(error);
      handleApiError(error, "Something went wrong!");
    }
  };

  useEffect(() => {
    fetchWaTeamVersionTwoData();
  }, [JSON.stringify(tableParams)]);

  const handleChangeWaTeamVersionTwo = (e) => {
    const { name, value } = e.target;
    setWaTeamVersionTwo({
      ...wateamversiontwo,
      [name]: value,
    });
  };

  const handleAddWaTeamVersionTwo = (e) => {
    e.preventDefault();

    const wateamversiontwoData = {
      ...wateamversiontwo,
    };
    if (editWaTeamVersionTwoId) {
      axios
        .put(
          `/api/whatsappv2/update/${editWaTeamVersionTwoId}`,
          wateamversiontwoData
        )
        .then((res) => {
          setWaTeamVersionTwo({
            connectionname: "",
            apiurl: "",
            crmapikey: "",
            phonenumberid: "",
            whatsappbusinessid: "",
            accesstoken: "",
          });
          Swal.fire({
            title: "WaTeam V2 Updated successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchWaTeamVersionTwoData();
          });
        })
        .catch((error) => {
          // Swal.fire(
          //   "Error",
          //   "Error creating WaTeam V2. Please try again.",
          //   error
          // );
          handleApiError(error, "Error creating WaTeam V2. Please try again.");
        });
    } else {
      axios
        .post("/api/whatsappv2/create", wateamversiontwoData)
        .then((res) => {
          setWaTeamVersionTwo({
            connectionname: "",
            apiurl: "",
            crmapikey: "",
            phonenumberid: "",
            whatsappbusinessid: "",
            accesstoken: "",
          });
          Swal.fire({
            title: "WaTeam V2 Added successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchWaTeamVersionTwoData();
          });
        })
        .catch((error) => {
          // Swal.fire(
          //   "Error",
          //   "Error creating WaTeam V2. Please try again.",
          //   error
          // );
          handleApiError(error, "Error creating WaTeam V2. Please try again.");
        });
    }
  };

  const handleDeleteWaTeamVersionTwo = async (_id) => {
    // Show SweetAlert2 confirm dialog
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmed.isConfirmed) {
      // Show a loading spinner while holding the action
      Swal.fire({
        title: "Deleting...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .delete(`/api/whatsappv2/delete/${_id}`)
        .then((res) => {
          fetchWaTeamVersionTwoData();
          Swal.fire("Deleted!", "WaTeam V2 deleted successfully!", "success");
        })
        .catch((error) => {
          Swal.fire("Error", "Something went wrong!", error);
          handleApiError(error, "Something went wrong!");
        });
    }
  };

  const handleEditWaTeamVersionTwo = (_id) => {
    const selectedWaTeamVersionTwo = data.find((item) => item._id === _id);

    if (selectedWaTeamVersionTwo) {
      setEditWaTeamVersionTwoId(_id); // Set the ID of the contact being edited
      setWaTeamVersionTwo({
        connectionname: selectedWaTeamVersionTwo.connectionname,
        apiurl: selectedWaTeamVersionTwo.apiurl,
        crmapikey: selectedWaTeamVersionTwo.crmapikey,
        phonenumberid: selectedWaTeamVersionTwo.phonenumberid,
        whatsappbusinessid: selectedWaTeamVersionTwo.whatsappbusinessid,
        accesstoken: selectedWaTeamVersionTwo.accesstoken,
      }); // Populate the form fields with the selected contact data
    }
    setIsModalOpen(true);
  };

  const handleAddWaTeamVersionTwoButton = () => {
    setEditWaTeamVersionTwoId(null);
    setWaTeamVersionTwo({
      connectionname: "",
      apiurl: "",
      crmapikey: "",
      phonenumberid: "",
      whatsappbusinessid: "",
      accesstoken: "",
    });
  };

  const columns = [
    {
      title: "ID",
      key: "id",
      render: (text, record, index) => index + 1,
      fixed: "left",
      width: 50,
    },

    {
      title: "Connection Name",
      dataIndex: "connectionname",
      key: "connectionname",
      ellipsis: true,
    },
    {
      title: "API URL",
      dataIndex: "apiurl",
      key: "apiurl",
      ellipsis: true,
    },
    {
      title: "CRM API Key",
      dataIndex: "crmapikey",
      key: "crmapikey",
      ellipsis: true,
    },
    {
      title: "Phone No. ID",
      dataIndex: "phonenumberid",
      key: "phonenumberid",
      ellipsis: true,
    },
    {
      title: "Whatsapp Business ID",
      dataIndex: "whatsappbusinessid",
      key: "whatsappbusinessid",
      ellipsis: true,
    },
    {
      title: "Access Token",
      dataIndex: "accesstoken",
      key: "accesstoken",
      ellipsis: true,
    },

    {
      title: "ACTION",
      key: "action",
      width: 150,

      render: (text, record) => (
        <Space size="middle">
          <Link
            to={{
              pathname: `/dashboard/wateamvtwo/${record._id}/generaldetailsvtwo`,
              state: { entry: record }, // Pass the entire entry object as state
            }}
          >
            <button type="button" className="edit-btn">
              <i className="ri-eye-line"></i>
            </button>
          </Link>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            className="edit-btn"
            onClick={() => handleEditWaTeamVersionTwo(record._id)}
          >
            <i className="ri-pencil-fill"></i>
          </button>
          <button
            onClick={() => handleDeleteWaTeamVersionTwo(record._id)}
            className="delete-btn"
          >
            <i className="ri-delete-bin-fill"></i>
          </button>
        </Space>
      ),
    },
  ];

  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedData, setSearchedData] = useState([]);

  const fetchSearchData = async () => {
    if (searchQuery.trim() !== "") {
      setLoading(true);
      try {
        const response = await axios.get("/api/whatsappv2/searchwhatsappv2", {
          params: { query: searchQuery },
        });
        setSearchedData(response.data.contacts);
        // console.log(response.data.contacts);
      } catch (error) {
        console.error("Error fetching search data:", error);
        handleApiError(error, "Error fetching search data");
      } finally {
        setLoading(false);
      }
    } else {
      setSearchedData([]);
    }
  };

  useEffect(() => {
    fetchSearchData();
  }, [searchQuery]);

  const getDataSource = () => {
    if (searchQuery.trim() !== "") {
      // Display searched contacts if search query is present
      return searchedData;
    } else {
      // Display all contacts by default
      return data;
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchQuery(e.target.value);
  };

  return (
    <div className="page-content w-100">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">Wa-Team Version2</h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12">
            <div id="contactList" className="card">
              <div className="card-header py-3">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="d-flex flex-wrap flex-grow-1 gap-2">
                    {/* <!-- Button trigger modal --> */}

                    <form className="d-flex">
                      <input
                        className="form-control me-2"
                        type="search"
                        id="search"
                        placeholder="Search"
                        aria-label="Search"
                        value={searchQuery}
                        onChange={handleSearch}
                        // onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </form>

                    <button
                      type="button"
                      className="btn btn-primary add-btn"
                      onClick={handleAddWaTeamVersionTwoButton}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      <i className="ri-add-fill me-1 align-bottom"></i>
                      Wa-Team V2
                    </button>

                    {/* <!-- Modal --> */}
                    <div
                      className="modal fade"
                      id="exampleModal"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden={!isModalOpen}
                      // style={{ display: isModalOpen ? "block" : "none" }}
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              {editWaTeamVersionTwoId
                                ? "Update Wa-Team V2"
                                : "Add Wa-Team V2"}
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <Box>
                              <TextField
                                color="primary"
                                fullWidth
                                label="Connection Name"
                                name="connectionname"
                                value={wateamversiontwo.connectionname}
                                onChange={handleChangeWaTeamVersionTwo}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="API URL"
                                name="apiurl"
                                value={wateamversiontwo.apiurl}
                                onChange={handleChangeWaTeamVersionTwo}
                                margin="normal"
                                required
                                autoFocus
                              />
                              {/* <TextField
                                color="primary"
                                fullWidth
                                label="CRM API Key"
                                name="crmapikey"
                                value={wateamversiontwo.crmapikey}
                                onChange={handleChangeWaTeamVersionTwo}
                                margin="normal"
                                required
                                autoFocus
                              /> */}
                              <TextField
                                color="primary"
                                fullWidth
                                label="Phone Number ID"
                                name="phonenumberid"
                                value={wateamversiontwo.phonenumberid}
                                onChange={handleChangeWaTeamVersionTwo}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Whatsapp Business ID"
                                name="whatsappbusinessid"
                                value={wateamversiontwo.whatsappbusinessid}
                                onChange={handleChangeWaTeamVersionTwo}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Access Token"
                                name="accesstoken"
                                value={wateamversiontwo.accesstoken}
                                onChange={handleChangeWaTeamVersionTwo}
                                margin="normal"
                                required
                                autoFocus
                              />
                            </Box>
                          </div>
                          <div className="modal-footer">
                            <button
                              onClick={handleAddWaTeamVersionTwo}
                              type="button"
                              className="btn btn-primary"
                              data-bs-dismiss="modal"
                            >
                              {editWaTeamVersionTwoId ? "Update" : "Ok"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0"></div>
                </div>
                <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                  <div className="flex-shrink-0">
                    <div className="hstack text-nowrap gap-2 align-item-center"></div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <Table
                  dataSource={getDataSource()}
                  columns={columns}
                  rowKey="_id"
                  // scroll={{ x: true }}
                  // style={{ overflowX: data.length > 5 ? "scroll" : "hidden" }} // Show scrollbar only if data is lengthy
                  // pagination={{
                  //   pageSize: 5,
                  // }}
                  pagination={{
                    ...tableParams.pagination,
                    position: "bottomRight",
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "15", "20", "50", "100"],
                  }}
                  onChange={handleTableChange}
                  components={{
                    header: {
                      cell: ({ style, ...restProps }) => (
                        <th
                          {...restProps}
                          style={{
                            ...style,
                            backgroundColor: "#c6c6c6",
                            color: "black",
                            textAlign: "center",
                          }}
                        />
                      ),
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaTeamVersion2;
